// extracted by mini-css-extract-plugin
export default {"corecard":"coremembercard_corecard__49bv3","core":"coremembercard_core__uRRJE","corename":"coremembercard_corename__h1J-J","coredomain":"coremembercard_coredomain__o7z01"};